import {createRouter, createWebHashHistory, createWebHistory} from "vue-router";

// history: createWebHistory(import.meta.env.BASE_URL),
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', name: 'schouwing', component: () => import('../pages/schouwing/index.vue') },
    { path: '/download_pdf', name: 'downloadPdf', component: () => import('../pages/schouwing/downloadPdf.vue') }
  ],
});

export default router
